import styled, { css } from 'styled-components'

export const Container = styled.div<{ $disabled: boolean }>`
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  gap: var(--space-300);
  align-items: center;
  justify-content: space-between;
  padding: var(--space-100) var(--space-300);

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
    `}
`

export const Label = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
  user-select: none;
`

export const Icon = styled.div`
  color: var(--icon-secondary);
`

export const Content = styled.div<{ minWidth?: number }>`
  ${({ minWidth }) =>
    minWidth &&
    css`
      min-width: calc(${minWidth}px - var(--space-200));
    `}
`
